export default {
  contacts: (state) => state.contacts,
};
